(() => {
  const help = document.querySelector('[data-fv-help]');
  if (!help) return;

  const search = help.querySelector('[data-fv-help-search]');
  const clear = help.querySelector('[data-fv-help-clear]');
  const reset = help.querySelector('[data-fv-help-reset]');
  const result = help.querySelector('[data-fv-help-result]');
  const empty = help.querySelector('[data-fv-help-empty]');
  const filters = [...help.querySelectorAll('[data-fv-help-filter]')];
  const questions = [...help.querySelectorAll('[data-fv-help-faq]')];
  let category = 'all';

  const normalise = (value) => value.toLowerCase().replace(/\s+/g, ' ').trim();

  const apply = () => {
    const query = normalise(search.value);
    let visible = 0;

    questions.forEach((question) => {
      const categoryMatch = category === 'all' || question.dataset.category === category;
      const searchMatch = !query || normalise(question.dataset.search || '').includes(query);
      const show = categoryMatch && searchMatch;
      question.hidden = !show;
      if (!show) question.open = false;
      if (show) visible += 1;
    });

    clear.hidden = !query;
    empty.hidden = visible !== 0;
    result.textContent = query || category !== 'all'
      ? `${visible} ${visible === 1 ? 'answer' : 'answers'} found`
      : '';
  };

  filters.forEach((filter) => {
    filter.addEventListener('click', () => {
      category = filter.dataset.fvHelpFilter;
      filters.forEach((item) => {
        const active = item === filter;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      apply();
    });
  });

  search.addEventListener('input', () => {
    if (search.value.trim()) {
      category = 'all';
      filters.forEach((item) => {
        const active = item.dataset.fvHelpFilter === 'all';
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
    }
    apply();
  });

  const showAll = () => {
    search.value = '';
    category = 'all';
    filters.forEach((item) => {
      const active = item.dataset.fvHelpFilter === 'all';
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    apply();
    search.focus();
  };

  clear.addEventListener('click', showAll);
  reset.addEventListener('click', showAll);
  search.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') showAll();
  });
})();
